import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { toDateType, toTwoDecimals } from '../../plugins';

/**
 * OrderInfoCard Component
 * Displays order information including order ID, date, amount due, and due date
 * Memoized to prevent unnecessary re-renders
 */
const OrderInfoCard = React.memo(({ order }) => {
    if (!order || !Object.keys(order).length) {
        return null;
    }

    return (
        <>
            <h4 className='mb-3'>Order Information</h4>
            <div className='check-card mb-4'>
                <Row>
                    <Col md={3} xs={6}>
                        <Form.Group className='form-group'>
                            <Form.Label className='mb-2'>
                                Order ID
                            </Form.Label>
                            <div className='form-group-content'>
                                <p>
                                    {order.synced
                                        ? order.OrderNbr.value
                                        : 'Not Available'}
                                </p>
                            </div>
                        </Form.Group>
                    </Col>
                    <Col md={3} xs={6}>
                        <Form.Group className='form-group'>
                            <Form.Label className='mb-2'>
                                Order Date
                            </Form.Label>
                            <div className='form-group-content'>
                                <p>
                                    {order.RequestedOn?.value
                                        ? toDateType(order.RequestedOn.value)
                                        : 'Not available'}
                                </p>
                            </div>
                        </Form.Group>
                    </Col>
                    <Col md={3} xs={6}>
                        <Form.Group className='form-group'>
                            <Form.Label className='mb-2'>
                                Amount Due
                            </Form.Label>
                            <div className='form-group-content'>
                                <p className='text-danger fw-bold'>
                                    {order.DueAmount?.value
                                        ? '$' + toTwoDecimals(Number(order.DueAmount.value))
                                        : '-'}
                                </p>
                            </div>
                        </Form.Group>
                    </Col>
                    <Col md={3} xs={6}>
                        <Form.Group className='form-group'>
                            <Form.Label className='mb-2'>
                                Date Due
                            </Form.Label>
                            <div className='form-group-content'>
                                <p className='text-danger'>
                                    {order.DueDate?.value
                                        ? toDateType(order.DueDate.value)
                                        : '-'}
                                </p>
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            </div>
        </>
    );
});

OrderInfoCard.displayName = 'OrderInfoCard';

export default OrderInfoCard;

